
import { ClaimHeader, ClaimListDetails } from "../../modules/claim/models/claimList.models";
import { IEnrolmentResDto, beneficiaryDetailsDto, policyDetailsDto, HealthBenefitsResDto, HealthCheckPartnerServicesResDto, VendorUrlServicesDto, FlexDetailsResponseDTO, CorporateConfigResponseDTO } from "../../modules/home/home.model";
import { IntimationDetails } from "../../modules/intimation/IntimationModel";
import {ActionType} from "../action-type/index";
import { corporate_config_Res, flex_polices_Res, HealthBenefits_Res, healthPatnerServices_Res, IActiveCalim_Res,  IActiveIntimation_Res, IBenefRes, IClaimRes, Ienrolment_Res, vendor_url_Res } from "../interface/homeInterface";
interface IinitialState {
    loading:boolean,
    error:any,
    beneficiaryDetails:Array<beneficiaryDetailsDto>,
    policyDetails:Array<policyDetailsDto>,
    claims:Array<ClaimHeader>,
    intimations:Array<IntimationDetails>
    enrolments?:IEnrolmentResDto,
    ClaimList?:Array<ClaimListDetails>,
    timeStamp:any,
    healthBenefits?:HealthBenefitsResDto,
    healthCheckPartnerServices?:HealthCheckPartnerServicesResDto,
    vendorUrls?:VendorUrlServicesDto,
    vendorId: number;
    flexPolicies: FlexDetailsResponseDTO
    corporateConfig: CorporateConfigResponseDTO,
    dataloaded : null
}

const initialState:IinitialState ={
    loading:false,
    error:null,
    beneficiaryDetails:[],
    policyDetails:[],
    claims:null,
    intimations:null,
    ClaimList:null,
    enrolments:{},
    timeStamp:null,
    healthBenefits:null,
    healthCheckPartnerServices:null,
    vendorUrls:null,
    vendorId: null,
    flexPolicies:null,
    corporateConfig: null,
    dataloaded : null
};

export const fetch_Beneficiaries_And_Policy_Details_Reducer = (state:IinitialState = initialState, action:IBenefRes) => {
    switch (action.type) {
        case ActionType.FETCH_BENEFICIARY_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_BENEFICIARY_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                beneficiaryDetails:action.beneficiaryDetails,
                policyDetails:action.policyDetails,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_BENEFICIARY_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_ActiveClaims_Details_Reducer = (state:IinitialState = initialState, action:IActiveCalim_Res) => {
    switch (action.type) {
        case ActionType.FETCH_ACTIVECLAIM_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_ACTIVECLAIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                claims:action.claims,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_ACTIVECLAIM_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_ActiveIntimation_Details_Reducer = (state:IinitialState = initialState, action:IActiveIntimation_Res) => {
    switch (action.type) {
        case ActionType.FETCH_ACTIVECINTIMATION_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_ACTIVECINTIMATION_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                intimations:action.intimations,
                timeStamp:action.timeStamp,
                dataloaded: true
            }
        case ActionType.FETCH_ACTIVECINTIMATION_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
                dataloaded: false
            }
        default:
            return state
    }
}
export const fetch_Enrolments_Details_Reducer = (state:IinitialState = initialState, action:Ienrolment_Res) => {
    switch (action.type) {
        case ActionType.FETCH_ENROLMENT_DETAILS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_ENROLMENT_DETAILS_SUCCESS:
            return {
                ...state,
                loading:false,
                enrolments:action.enrolments,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_ENROLMENT_DETAILS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}


export const fetch_Health_Benefits_Reducer = (state:IinitialState = initialState, action:HealthBenefits_Res) => {
    switch (action.type) {
        case ActionType.FETCH_HEALTH_BENEFITS_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_HEALTH_BENEFITS_SUCCESS:
            return {
                ...state,
                loading:false,
                healthBenefits:action.healthBenefits,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_HEALTH_BENEFITS_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}


export const fetch_Health_Check_Partner_Services_Reducer = (state:IinitialState = initialState, action:healthPatnerServices_Res) => {
    switch (action.type) {
        case ActionType.FETCH_HEALTH_HEALTH_CHECK_PARTNER_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_HEALTH_CHECK_PARTNER_SUCCESS:
            return {
                ...state,
                loading:false,
                healthCheckPartnerServices:action.healthCheckPartnerServices,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_HEALTH_CHECK_PARTNER_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_Vendor_Url_Reducer = (state:IinitialState = initialState, action:vendor_url_Res) => {
    switch (action.type) {
        case ActionType.FETCH_VENDOR_URL_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_VENDOR_URL_SUCCESS:
            return {
                ...state,
                loading:false,
                vendorUrls:action.vendorUrls,
                vendorId: action.vendorId,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_VENDOR_URL_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_Flex_Policies_Reducer = (state:IinitialState = initialState, action:flex_polices_Res) => {
    switch (action.type) {
        case ActionType.FETCH_FLEX_POLICIES_START:
            return{
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_FLEX_POLCIES_SUCCESS:
            return {
                ...state,
                loading:false,
                flexPolicies:action.flexPolicies,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_FLEX_POLCIES_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}

export const fetch_Corporate_Config_Reducer = (state:IinitialState = initialState, action:corporate_config_Res) => {
    switch (action.type) {
        case ActionType.FETCH_CORPORATE_CONFIG_START:
            return {
                ...state,
                loading:true,
                error: null,
            }
        case ActionType.FETCH_CORPORATE_CONFIG_SUCCESS:
            return {
                ...state,
                loading:false,
                corporateConfig :action.corporateConfig,
                timeStamp:action.timeStamp,
            }
        case ActionType.FETCH_CORPORATE_CONFIG_FAIL:
            return {
                ...state,
                loading:false,
                error:action.payload,
            }
        default:
            return state
    }
}